// Padrão da reforma tributária (NT 2025.002-RTC) com as alíquotas-teste de 2026.
// Mantenha em sincronia com ProductTax::IBS_CBS_DEFAULT.
export const IBS_CBS_DEFAULT = {
  CST: '000',
  cClassTrib: '000001',
  pCBS: '0.90',
  pIBSUF: '0.10',
  pIBSMun: '0.00',
  pRedAliq: null
};

export const IBS_CBS_CST = [
  { value: '000', label: '000 - Tributação integral' },
  { value: '200', label: '200 - Alíquota reduzida' }
];

export const withIbsCbsDefault = (ibsCbs = {}) => ({ ...IBS_CBS_DEFAULT, ...ibsCbs });
